<template>
    <l-map
        ref="map"
        :zoom="zoomLevel"
        :center="[lat, lng]"
        :options="mapOptions"
        class="vrm-location-pin"
        @ready="configure"
    >
        <l-tile-layer :url="tilesUrl" :attribution="attribution" />
        <l-marker :lat-lng="[lat, lng]">
            <l-icon :icon-anchor="[0, 0]" :icon-size="[0, 0]">
                <div class="vrm-location-pin__marker" />
            </l-icon>
        </l-marker>
    </l-map>
</template>
<style scoped lang="less">
.vrm-location-pin {
    .vrm-location-pin__marker {
        @outerDiameter: 20px;
        @innerDiameter: 10px;
        @torusSize: (@outerDiameter - @innerDiameter) / 2;

        // Outer dot
        width: @outerDiameter;
        height: @outerDiameter;
        background: white;
        border-radius: 50%;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.24);

        // Inner dot
        position: relative;
        &::after {
            content: '';
            position: absolute;
            top: @torusSize;
            bottom: @torusSize;
            left: @torusSize;
            right: @torusSize;
            background: #388fcf;
            border-radius: 50%;
            box-shadow: 0 0 3px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.24);
        }

        // Center marker over parent origin
        transform: translate(-50%, -50%);

        // Prevent user interactions
        pointer-events: none;
        user-select: none;
    }

    // Make the attribution a full-width footer
    /deep/ .leaflet-bottom.leaflet-right {
        left: 0;
        .leaflet-control-attribution {
            float: none;
            text-align: center;
            padding: 0;

            // Prevent text wrapping & hide overflow
            text-overflow: clip;
            overflow: hidden;
            white-space: nowrap;
        }
    }
}
</style>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { vrmConfig } from '@/config';

@Component({ components: { LMap, LTileLayer, LMarker, LIcon } })
@AngularDirective('vrm-location-pin')
export default class VrmLocationPin extends Vue {
    @Prop({ default: 52.3676 })
    lat;
    @Prop({ default: 4.9041 })
    lng;
    @Prop({ default: 8 })
    zoomLevel;
    @Prop({ default: false })
    draggable;
    leaflet = null;

    get mapOptions() {
        return {
            // Disable controls
            attributionControl: true,
            zoomControl: false,
            // Limit zooming
            minZoom: this.zoomLevel,
            maxZoom: this.zoomLevel,
        };
    }

    configure(leaflet) {
        this.leaflet = leaflet;
    }

    @Watch('draggable', { immediate: true })
    @Watch('leaflet')
    applyDragging() {
        if (this.leaflet) {
            const elements = [
                this.leaflet.dragging,
                this.leaflet.touchZoom,
                this.leaflet.doubleClickZoom,
                this.leaflet.scrollWheelZoom,
            ];
            if (this.draggable) {
                elements.forEach(h => h.enable());
            } else {
                elements.forEach(h => h.disable());
            }
        }
    }

    get tilesUrl() {
        // return 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        return `${vrmConfig.api}/osm-tile/{z}/{x}/{y}`;
    }

    get attribution() {
        return `&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors`;
    }
}
</script>
